export default [
  {
    component: () => import('../pages/returns-page.vue'),
    name: 'attaching.returns',
    path: '/:slug/attaching/returns',
  },
]
